import { STATUS } from "@/lib/api";
import { BadgeCheck } from "lucide-react";

const fmt = (d) => (d ? d.split("-").reverse().join("/") : "—");

export const ClientTag = ({ c, big, testid }) => {
  const st = STATUS[c.status] || {};
  return (
    <span data-testid={testid} className={`inline-flex max-w-full flex-wrap items-center gap-x-1.5 gap-y-0.5 rounded-md border border-emerald-500/40 bg-emerald-500/15 font-semibold text-emerald-200 ${big ? "px-2.5 py-1 text-xs" : "mt-1 px-1.5 py-0.5 text-[10px]"}`}>
      <BadgeCheck className={big ? "h-4 w-4 text-emerald-300" : "h-3 w-3 text-emerald-300"} />
      <span>Cliente</span>
      <span className="font-mono">{c.panel_user}</span>
      <span className="opacity-60">·</span><span>{c.account}</span>
      <span className="opacity-60">·</span><span style={{ color: st.text }}>{st.label || c.status}</span>
      {big && <><span className="opacity-60">·</span><span>vence {fmt(c.due_date)}</span></>}
    </span>
  );
};
